import { createFileRoute } from '@tanstack/react-router';
import { InterviewsPane } from '@/components/health-readiness/panes';

/** Health & Readiness → Interview notes (T-0242). T-0244 redraws it. */
export const Route = createFileRoute('/engagements/$engagementId/health-readiness/interviews')({
  component: InterviewsRoute,
});

function InterviewsRoute() {
  const { engagementId } = Route.useParams();
  return <InterviewsPane engagementId={engagementId} />;
}
